import { RESET, SET_SHOW_CHILD_CARDS } from "./childCardFilter.actionTypes";

const initialState = {
  showChildCards: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_CHILD_CARDS: {
      return { ...state, showChildCards: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
